module.exports = __webpack_public_path__ + "img/132.1.b81ff7e5.jpg";